import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import { Container, Row, Col, Tabs, Tab, Form, Table } from "react-bootstrap";
import { Link, useLoaderData, useLocation } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import ProfitLossHistory from "./ProfitLossHistory";
import moment from "moment";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";
const ProfitLoss = () => {
  const [currentDateTime, setCurrentDateTime] = useState("");
  let { user, isLoader, setLoader, setAccountError, profileData } =
    useContext(AuthContext);
  const location = useLocation();
  const [total2, setTotal2] = useState(0);
  const [data2, setData2] = useState({});
  const [innertab, setInnertab] = useState("all");
  const getCurrentDateTIme = () => {
    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        today.getHours() +
        ":" +
        today.getMinutes();

    setCurrentDateTime(date);
  };

  useEffect(() => {
    getCurrentDateTIme();
  }, []);
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [key, setKey] = useState("Exchange");
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    page: 1,
    limit: 50,
  });
  const [data, setData] = useState([]);

  const handelChange = (value, newTab) => {
    if (newTab == "casino") {
      return value?.reduce((a, v) => {
        return parseFloat(a) + parseFloat(v.playerPL);
      }, 0);
    } else {
      let temp = value
        ?.filter((res) => {
          return res?.bets_list?.length > 0;
        })
        ?.map((item) => {
          const backTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "back" &&
              v?.teamSelectionWin === v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }

            return a;
          }, 0);
          const backTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "back" &&
              v?.teamSelectionWin !== v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);

          let backSubTotalresult =
            backTotalProfitAmount > backTotalLoseAmount
              ? backTotalProfitAmount - backTotalLoseAmount
              : -(backTotalLoseAmount - backTotalProfitAmount);

          const layTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "lay" &&
              v?.teamSelectionWin !== v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);

          const layTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (
              v?.betType === "lay" &&
              v?.teamSelectionWin === v?.selectionId
            ) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);

          let laySubTotalresult =
            layTotalProfitAmount > layTotalLoseAmount
              ? layTotalProfitAmount - layTotalLoseAmount
              : -(layTotalLoseAmount - layTotalProfitAmount);
          let marketSubTotal = backSubTotalresult + laySubTotalresult;
          const yesTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "Yes" && v?.decisionRun >= v?.betRun) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);

          const yesTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "Yes" && v?.decisionRun < v?.betRun) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);
          let yesSubTotalresult =
            yesTotalProfitAmount > yesTotalLoseAmount
              ? yesTotalProfitAmount - yesTotalLoseAmount
              : -(yesTotalLoseAmount - yesTotalProfitAmount);

          const noTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "No" && v?.decisionRun < v?.betRun) {
              a = parseFloat(a) + parseFloat(v.profitAmount);
            }
            return a;
          }, 0);
          const noTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
            if (v?.type == "No" && v?.decisionRun >= v?.betRun) {
              a = parseFloat(a) + parseFloat(v.loseAmount);
            }
            return a;
          }, 0);
          let noSubTotalresult =
            noTotalProfitAmount > noTotalLoseAmount
              ? noTotalProfitAmount - noTotalLoseAmount
              : -(noTotalLoseAmount - noTotalProfitAmount);

          let fancyMarketSubTotal = yesSubTotalresult + noSubTotalresult;
          let fancyNetAmount = fancyMarketSubTotal;
          let v =
            marketSubTotal > 0
              ? !isEmpty(profileData?.commission)
                ? (marketSubTotal * profileData?.commission) / 100
                : marketSubTotal / 100
              : "";
          let netAmount = 0;
          let betType =
            newTab == "Exchange"
              ? "betfair"
              : newTab == "sportsBook"
              ? "sportBook"
              : newTab;

          if (betType == "toss" || betType == "tie") {
            netAmount = marketSubTotal;
          } else if (betType == "FancyBet") {
            netAmount = fancyNetAmount;
          } else {
            netAmount = marketSubTotal - v;
          }

          return netAmount;
        });
      return temp.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
    }
  };
  const getData = async (type) => {
    setLoader(true);
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }

    let obj = {
      ...filter,
      betType:
        key == "Exchange"
          ? "betfair"
          : key == "FancyBet"
          ? "fancy"
          : key == "Sportsbook"
          ? "sportBook"
          : key == "BookMaker"
          ? "bookmaker"
          : key == "Tie"
          ? "tie"
          : key == "Toss"
          ? "toss"
          : key == "parlay"
          ? "parlay"
          : "casino",
    };

    const { status, data: response_users } = await apiGet(
      apiPath.getProfitLoss,
      obj
    );
    if (status === 200) {
      if (response_users.success) {
        setLoader(false);
        setData(response_users?.results);
        setData2(response_users?.results);
        setInnertab("all");
        if (response_users?.results?.data?.length > 0) {
          let result = handelChange(response_users?.results?.data, key);
          setTotal(result);
          setTotal2(result);
        }
        if (response_users?.results?.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
      } else {
        setLoader(false);
        setData("");
        setAccountError(true);
      }
    } else {
      setLoader(false);
      setData("");
    }
  };
  // useEffect(() => {
  //   if (filter.filterByDay != "") {
  //     getData();
  //   }
  // }, [filter.filterByDay]);
  // useEffect(() => {
  //   if (viewpage) {
  //     getData();
  //   }
  // }, [viewpage]);

  useEffect(() => {
    if (innertab == "all") {
      if (data?.data?.length > 0) {
        let result = handelChange(data?.data, key);
        setTotal2(result);
        setData2(data);
      }
    } else {
      let filtered = data?.data?.filter((res) => {
        return res?.eventType == innertab;
      });

      if (filtered?.length > 0) {
        let result = handelChange(filtered, key);
        setTotal2(result);
        setData2((prev) => {
          return {
            ...prev,
            data: filtered,
          };
        });
      } else {
        setData2([]);
        setTotal2(0);
      }
    }
  }, [innertab]);

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  useEffect(() => {
    setPageCount(data?.totalPages || []);
  }, [data]);

  useEffect(() => {
    setViewPage(filter?.page ? filter.page - 1 : 0);
  }, [filter]);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      getData();
    }
  }, [filter?.page]);
  return (
    <>
      <div className={isMobile ? "" : "main_wrap"}>
        <section className=" main-inner-outer">
          <Container fluid>
            <div className="main_content_row">
              <Sidebar />

              <div className="mt-3 my_account_main profitloss-tab-new">
                <div className="inner-wrapper">
                  <h2 className="common-heading">My Bets</h2>

                  <div className="bet-history-menu">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          to={
                            location?.pathname?.split("/")[2] == "mobile"
                              ? "/mybets/mobile"
                              : "/mybets"
                          }
                        >
                          Current Bets
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            location?.pathname?.split("/")[2] == "mobile"
                              ? "/betshistory/mobile"
                              : "/betshistory"
                          }
                        >
                          Bets History
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={
                            location?.pathname?.split("/")[2] == "mobile"
                              ? "/profit_loss/mobile"
                              : "/profit_loss"
                          }
                          className="active"
                        >
                          Profit & Loss
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="common-tab mb-3">
                    <div className="profile-wallet-heading bg-white p-2">
                      <h4>Profit & Loss - Main wallet</h4>
                      <ul className="acc-info">
                        <li className="user">
                          {user && user?.user?.username
                            ? user?.user?.username
                            : ""}
                        </li>
                        <li className="time">{currentDateTime}</li>
                      </ul>
                    </div>

                    <Tabs
                      id="controlled-tab-example"
                      defaultActiveKey="Exchange"
                      activeKey={key}
                      onSelect={(k) => {
                        setKey(k);
                        setFilter({
                          betType: "",
                          status: "completed",
                          fromPeriod: previousDate,
                          toPeriod: currentDate,
                          filterByDay: "",
                          page: 1,
                          limit: 10,
                        });
                        setData({});
                        setTotal(0);
                        setTotal2(0);
                        setInnertab("all");
                        setData2({});
                      }}
                    >
                      <Tab eventKey="Exchange" title="Exchange">
                        {key === "Exchange" && (
                          <ProfitLossHistory
                            betType={"betfair"}
                            filter={filter}
                            innerType={"Exchange"}
                            setFilter={setFilter}
                            title={key}
                            data={data2}
                            dataOld={data}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="FancyBet" title="FancyBet">
                        {key === "FancyBet" && (
                          <ProfitLossHistory
                            betType={"fancy"}
                            filter={filter}
                            setFilter={setFilter}
                            innerType={"FancyBet"}
                            title={key}
                            data={data2}
                            dataOld={data}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            setInnertab={setInnertab}
                            total={total}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>{" "}
                      <Tab eventKey="casino" title="Casino">
                        {key === "casino" && (
                          <ProfitLossHistory
                            betType={"casino"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            data={data2}
                            getData={getData}
                            dataOld={data}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="Sportsbook" title="Sportsbook">
                        {key === "Sportsbook" && (
                          <ProfitLossHistory
                            betType={"sportBook"}
                            filter={filter}
                            setFilter={setFilter}
                            title={key}
                            dataOld={data}
                            innerType={"sportsBook"}
                            data={data2}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="BookMaker" title="BookMaker">
                        {key === "BookMaker" && (
                          <ProfitLossHistory
                            betType={"bookmaker"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            dataOld={data}
                            innerType={"BookMaker"}
                            data={data2}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="BPoker" title="BPoker">
                        {key === "BPoker" && (
                          <ProfitLossHistory
                            betType={"bookmaker"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            dataOld={[]}
                            innerType={"BPoker"}
                            data={[]}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="SABA" title="SABA">
                        {key === "SABA" && (
                          <ProfitLossHistory
                            betType={"bookmaker"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            dataOld={[]}
                            innerType={"SABA"}
                            data={[]}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="MiniGame" title="MiniGame">
                        {key === "MiniGame" && (
                          <ProfitLossHistory
                            betType={"bookmaker"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            dataOld={[]}
                            innerType={"MiniGame"}
                            data={[]}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                      <Tab eventKey="Royal" title="Royal">
                        {key === "Royal" && (
                          <ProfitLossHistory
                            betType={"bookmaker"}
                            title={key}
                            filter={filter}
                            setFilter={setFilter}
                            dataOld={[]}
                            innerType={"Royal"}
                            data={[]}
                            getData={getData}
                            viewpage={viewpage}
                            handlePageClick={handlePageClick}
                            pageCount={pageCount}
                            isLoader={isLoader}
                            total={total}
                            setInnertab={setInnertab}
                            innertab={innertab}
                            total2={total2}
                            handelChange={handelChange}
                          />
                        )}
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default ProfitLoss;
